import React from "react";

import { DownIcon, CloseIcon } from "../Icons";

function CustomFieldDropdownList({ label, fieldInfo, field, fieldValue, userFieldErrors, isMobile, commonInputProps }) {
  const key = commonInputProps.id;
  const choices = fieldInfo.choices || [];
  const hasValues = !!field.value?.length;
  const dropdownSize = choices.length > 12 ? 12 : choices.length || 1;
  const shownValues = field.value?.map((v) => choices.find((c) => c.value === v)?.label ?? v).join(", ");

  const handleClearValue = () => field.onChange(undefined);

  const handleValuesFocus = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const selectElement = event.target.closest(".dropdownMultipleContainer").querySelector("select");
    if (selectElement) {
      selectElement.focus();
    }
  };

  return (
    <div data-cy={commonInputProps["data-cy"]}>
      {label}
      <div className={`dropdownMultipleContainer ${isMobile ? "isMobile" : ""}`}>
        <select {...commonInputProps} size={dropdownSize} multiple>
          {choices.map((opt) => (
            <option key={`${key}.${opt.value}`} value={opt.value} selected={fieldValue?.includes(opt.value)}>
              {opt.label}
            </option>
          ))}
        </select>
        <div className="blurredValues" onClick={handleValuesFocus}>
          {shownValues}
        </div>
        <div className="actionIcons" style={{ pointerEvents: hasValues ? "auto" : "none" }}>
          {!commonInputProps.disabled && hasValues ? (
            <button onClick={handleClearValue} aria-label={`Clear ${label}`}>
              <CloseIcon />
            </button>
          ) : (
            <DownIcon />
          )}
        </div>
      </div>
      <div className="errorlist" data-cy={`error-${key}`}>
        {userFieldErrors.map((err, i) => (
          <div key={i}> {err} </div>
        ))}
      </div>
    </div>
  );
}

export default CustomFieldDropdownList;
